import { useState, useEffect, useCallback } from 'react'

import { useAppSelector } from '~/redux/hooks'

import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'

import SVGImage from '~/components/Image/SVGImage'

import { QuizCounterAndTimerProps } from './QuizProps.models'

const QuizQuestionCounterAndTimer: React.FC<QuizCounterAndTimerProps> = ({
  total = null,
  current = null,
  startTime = null,
  cancelQuiz = () => {},
}) => {
  const [timeDifference, setTimeDifference] = useState<Date | null>(null)
  const colorInfo = useAppSelector(selectVideoTopicColor)

  const calculateAndSetTimeDifference = useCallback(() => {
    if (!startTime) return
    const td = new Date(new Date().getTime() - startTime.getTime())
    setTimeDifference(td)
  }, [setTimeDifference, startTime])

  useEffect(() => {
    if (!startTime) return
    calculateAndSetTimeDifference()

    const timerRef = setInterval(() => {
      calculateAndSetTimeDifference()
    }, 1000)

    return () => {
      clearInterval(timerRef)
    }
  }, [calculateAndSetTimeDifference, startTime])

  const getTimerComponent = (): React.ReactElement => {
    if (!timeDifference) return <></>
    const hours = timeDifference.getHours().toString().padStart(2, '0')
    const minutes = timeDifference.getMinutes().toString().padStart(2, '0')
    const seconds = timeDifference.getSeconds().toString().padStart(2, '0')
    return (
      <span>
        {hours} : {minutes} : {seconds}
      </span>
    )
  }
  return (
    <div className="flex pt-4">
      <div className={`flex-1 ${colorInfo.textClass}`}>
        {current || 0}
        {total ? `/${total}` : ''}
      </div>
      <div className="flex flex-1 justify-center">{getTimerComponent()}</div>
      <div className="flex-1 flex justify-end">
        <SVGImage
          height={25}
          imageClassName="cursor-pointer hover:bg-purple-bright hover:bg-opacity-50 transition duration-300 ease-in-out rounded-0.5 p-1"
          onClick={cancelQuiz}
          srcKey="onboarding/icons/exit.svg"
          width={25}
        />
      </div>
    </div>
  )
}

export default QuizQuestionCounterAndTimer
